module.exports = {"532801001":"允景洪街道","532801102":"嘎洒镇","532801103":"勐龙镇","532801104":"勐罕镇","532801105":"勐养镇","532801106":"普文镇","532801202":"景哈哈尼族乡","532801203":"景讷乡","532801204":"大渡岗乡","532801205":"勐旺乡","532801206":"基诺山基诺族乡","532801401":"景洪农场","532801402":"东风农场","532801403":"橄榄坝农场","532801404":"勐养农场","532801405":"大渡岗农场","532801406":"西双版纳州度假区管理委员","532801407":"景洪工业园区","532801408":"西双版纳监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532801.json
// module id = 2645
// module chunks = 0